<script setup>
import { onBeforeMount, onMounted, onBeforeUnmount } from "vue";
import { useStore } from "vuex";

import setNavPills from "@/assets/js/nav-pills.js";
import setTooltip from "@/assets/js/tooltip.js";
import ArgonButton from "@/components/ArgonButton.vue";
// import ArgonButton from "@/components/ArgonButton.vue";

const body = document.getElementsByTagName("body")[0];

const store = useStore();

onMounted(() => {
  store.state.isAbsolute = true;
  setNavPills();
  setTooltip();
});
onBeforeMount(() => {
  body.classList.add("profile-overview");
});
onBeforeUnmount(() => {
  body.classList.remove("profile-overview");
});
</script>
<template>
  <div class="card mb-4">
    <div class="card-header pb-4">
      <h6>Productos</h6>
      <argon-button
                  class="mt-4"
                  variant="gradient"
                  color="success"
                  size="sm"
                  @click.prevent="altaProducto"
                  >Alta</argon-button
  >
    </div>
    <div v-if="false" class="spinner-border text-primary" role="status">
      <span class="sr-only">Cargando...</span>
    </div>
    <div class="card-body px-0 pt-0 pb-2" v-else>
      <div class="table-responsive p-0">
        <table class="table align-items-center justify-content-center mb-0">
          <thead>
            <tr>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Id
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Codigo de Barra
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                Nombre
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                Cantidad
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                Stock Minimo
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                Fecha de creacion
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                Accion
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="producto in products" :key="producto.id">
              <td>
                <div class="d-flex px-2">
                  <div class="my-auto">
                    <h6 class="mb-0 text-sm">{{ producto.id }}</h6>
                  </div>
                </div>
              </td>
              <td>
                <p class="text-sm font-weight-bold mb-0">{{ producto.codeBar }}</p>
              </td>
              <td>
                <p class="text-sm font-weight-bold mb-0">
                  {{ producto.nombre }}
                </p>
              </td>
              <td>
                <span class="text-xs font-weight-bold">{{ producto.cantidad }}</span>
              </td>
              <td>
                <span class="text-xs font-weight-bold">{{ producto.minStock }}</span>
              </td>
              <td>
                <span class="text-xs font-weight-bold">{{
                  producto.fechaCreacion
                }}</span>
              </td>
              <td>
                <argon-button
                  class="mt-4"
                  variant="gradient"
                  color="info"
                  fullWidth
                  size="sm"
                  @click.prevent="updateProducto(producto)"
                  >Actualizar</argon-button
                >
              </td>
            </tr>
          </tbody>
        </table>
         
          <argon-pagination
            color="info"
            size="lg"
            class="justify-content-center"
          >
            <!-- Botón anterior -->
            <argon-pagination-item
              prev
              :disabled="paginaActual === 1"
              @click.native="getProductos(paginaActual - 1)"
            />

            <!-- Páginas -->
            <argon-pagination-item
              v-for="n in totalPaginas"
              :key="n"
              :active="paginaActual === n"
              :label="n.toString()"
              @click.native="getProductos(n)"
            />
            <argon-pagination-item
              next
              :disabled="paginaActual === totalPaginas"
              @click.native="getProductos(paginaActual + 1)"
            />
          </argon-pagination>
        
      </div>
      <product v-if="productUpdate" :product="productUpdate" />
      <altaproduct v-if="alta" />
    </div>
  </div>
</template>
<script>
import prod from "../Product.vue";
import Product from "../Product.vue";
import altaproduct from "../AltaProduct.vue";
import ArgonPagination from "@/components/ArgonPagination.vue";
import ArgonPaginationItem from "@/components/ArgonPaginationItem.vue";
import productos from "../../api/productos";
import Swal from "sweetalert2";
export default {
  components: { altaproduct, prod, Product,ArgonPagination, ArgonPaginationItem},
  data() {
    return {
      loading: true,
      status: null,
      token: "",
      products: [],
      productUpdate: null,
      paginaActual: 1,
      totalPaginas: 1,
      alta:false
      // userUpdate: {
      //   id: null,
      //   nombre: null,
      //   paterno: null,
      //   usuario: null,
      //   telefono: null,
      //   email: null,
      //   passwor: null,
      //   status: null,
      //   nivel: null,
      // },
      // model: {
      //   id: "",
      //   type: "registro",
      //   usuario: "",
      //   password: "",
      //   confirmPassword: "",
      //   nombre: "",
      //   paterno: "",
      //   telefono: "",
      //   errorMessage: "",
      //   status: false,
      //   token: "",
      // },
    };
  },
  onMounted() {},
  created() {
    this.token = localStorage.getItem("token");
    this.getProductos(1);
    
  },
  methods: {
    async getProductos(pagina) {
      this.productUpdate=null
      this.alta=false
      if(pagina>this.totalPaginas){
        pagina = this.totalPaginas
      }
      this.paginaActual=pagina
      productos
        .getProductos({ token: this.token, pagina: this.paginaActual })
        .then((result) => {
          if (result.data.productos != null) {
            this.products = result.data.productos;
            this.paginaActual = result.data.pagina_actual;
            this.totalPaginas = result.data.total_paginas;
            this.loading = false
          } else {
            Swal.fire({
              title: "Error al obtener productos",
              text: result.data.error,
              icon: "error",
              confirmButtonColor: "error",
              confirmButtonText: "Continuar",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async updateProducto(producto) {
      this.productUpdate = producto;
    },
    altaProducto(){
      this.alta = true
    }
  },
};
</script>
